"use strict";

var _regeneratorRuntime = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var big_decimal_1 = require("@logio/big-decimal");

var immutable_1 = require("immutable");

var moment = require("moment");

var stream_1 = require("stream");

var util_1 = require("util");

var Utils =
/*#__PURE__*/
function () {
  function Utils() {
    _classCallCheck(this, Utils);
  }

  _createClass(Utils, null, [{
    key: "getFarFutureMoment",

    /**
     * @returns a copy of a Moment which should be used internally for unbounded date (represented by null) in future.
     */
    value: function getFarFutureMoment() {
      return Utils.FAR_FUTURE.clone();
    }
    /**
     * Returns a copy of a Moment which is used in price-lists for infinite validity.
     */

  }, {
    key: "getFarFutureMomentForPriceList",
    value: function getFarFutureMomentForPriceList() {
      return Utils.FAR_FUTURE_PRICELIST.clone();
    }
    /**
     * @returns a copy of a Moment which should be used internally for unbounded date in past.
     */

  }, {
    key: "getFarPastMoment",
    value: function getFarPastMoment() {
      return Utils.FAR_PAST.clone();
    }
    /*
     * Basic types check
     */

    /**
     * Check if reference is to object and value is not null and not array
     *
     * @param ref Reference to value
     * @returns true if ref is object
     */

  }, {
    key: "isObject",
    value: function isObject(ref) {
      return typeof ref === 'object' && ref !== null && !Array.isArray(ref);
    }
    /**
     * Checks whether reference is object (not null and not array) and is empty
     * @param ref
     * @returns true if ref is empty object, false otherwise
     */

  }, {
    key: "isEmptyObject",
    value: function isEmptyObject(ref) {
      return Utils.isObject(ref) && Object.keys(ref).length === 0;
    }
    /**
     * Check if reference has no defined value or null value.
     *
     * @param ref Reference to value
     * @returns true if ref has no value or null value
     */

  }, {
    key: "isValueMissing",
    value: function isValueMissing(ref) {
      return ref === undefined || ref === null;
    }
    /**
     * Negation of isValueMissing function.
     * @param ref Reference to value
     * @returns true if isValueMissing returns false
     */

  }, {
    key: "hasValue",
    value: function hasValue(ref) {
      return !this.isValueMissing(ref);
    }
    /**
     * Check if reference is to string.
     *
     * @param ref Reference to value
     * @returns true if ref is string
     */

  }, {
    key: "isString",
    value: function isString(ref) {
      return typeof ref === 'string';
    }
    /**
     * Checks if reference is to empty string.
     *
     * @param ref Reference to value
     * @returns true if ref is empty string
     */

  }, {
    key: "isEmptyString",
    value: function isEmptyString(ref) {
      return typeof ref === 'string' && ref.length === 0;
    }
    /**
     * Checks if reference is non-empty string.
     *
     * @param ref Reference to value
     * @returns true if ref is non-empty string
     */

  }, {
    key: "isNonEmptyString",
    value: function isNonEmptyString(ref) {
      return typeof ref === 'string' && ref.length !== 0;
    }
    /**
     * Check if reference is to number.
     *
     * @param ref Reference to value
     * @returns true if ref is number
     */

  }, {
    key: "isNumber",
    value: function isNumber(ref) {
      return typeof ref === 'number';
    }
    /**
     * Check if reference is to object that is instance of date.
     *
     * @param ref Reference to value
     * @returns true if ref is instance of date
     */

  }, {
    key: "isDate",
    value: function isDate(ref) {
      return ref instanceof Date;
    }
    /**
     * Check if reference is to object that is instance of moment
     *
     * @param ref Reference to value
     * @returns true if ref is instance of moment
     */

  }, {
    key: "isMoment",
    value: function isMoment(ref) {
      return moment.isMoment(ref);
    }
    /**
     * Check if not a number from mathjs lib - it can check BigDecimal class.
     *
     * @param ref Reference to value
     * @returns true if ref is not a number
     */

  }, {
    key: "isNaN",
    value: function isNaN(ref) {
      return ref instanceof big_decimal_1.BigDecimal && ref.isNaN();
    }
    /**
     * Check if refence is to boolean.
     *
     * @param ref Reference to value
     * @returns true if ref is not a boolean
     */

  }, {
    key: "isBool",
    value: function isBool(ref) {
      return typeof ref === 'boolean';
    }
    /**
     * Check if reference is null
     *
     * @param ref Reference to value
     * @returns true if ref is null
     */

  }, {
    key: "isNull",
    value: function isNull(ref) {
      return ref === null;
    }
    /**
     * Check if reference is undefined
     *
     * @param ref Reference to value
     * @returns true if ref is undefined
     */

  }, {
    key: "isUndefined",
    value: function isUndefined(ref) {
      return typeof ref === 'undefined';
    }
    /**
     * Check if reference is typeof function.
     *
     * @param ref Reference to value
     * @returns true if ref is not a function
     */

  }, {
    key: "isFunction",
    value: function isFunction(ref) {
      return typeof ref === 'function';
    }
    /**
     * Check if reference is to array and value is not null
     *
     * @param ref Reference to value
     * @returns true if ref is array
     */

  }, {
    key: "isArray",
    value: function isArray(ref) {
      return ref !== null && Array.isArray(ref);
    }
    /*
     * Basic type conversions
     */

  }, {
    key: "asArray",
    value: function asArray(arr) {
      if (!Utils.isArray(arr)) {
        throw new TypeError('Array expected: ' + typeof arr);
      }

      return arr;
    }
  }, {
    key: "asBool",
    value: function asBool(ref) {
      if (!Utils.isBool(ref)) {
        throw new TypeError('Boolean expected: ' + typeof ref);
      }

      return ref;
    }
  }, {
    key: "asString",
    value: function asString(ref) {
      if (!Utils.isString(ref)) {
        throw new TypeError('String expected: ' + typeof ref);
      }

      return ref;
    }
  }, {
    key: "asSEnum",
    value: function asSEnum(ref, enm) {
      var found = false;

      for (var k in enm) {
        if (enm.hasOwnProperty(k)) {
          found = found || enm[k] === ref;
        }
      }

      if (!found) {
        throw new TypeError('String enumeration expected: ' + ref + '(' + typeof ref + ')');
      }

      return ref;
    }
  }, {
    key: "asStringOrNull",
    value: function asStringOrNull(ref) {
      if (Utils.isValueMissing(ref)) {
        return null;
      }

      return Utils.asString(ref);
    }
  }, {
    key: "asNumber",
    value: function asNumber(ref) {
      if (!Utils.isNumber(ref)) {
        throw new TypeError('Number expected: ' + typeof ref);
      }

      return ref;
    }
  }, {
    key: "asDate",
    value: function asDate(ref) {
      if (!Utils.isDate(ref)) {
        throw new TypeError('Date expected: ' + typeof ref);
      }

      return ref;
    }
  }, {
    key: "asMoment",
    value: function asMoment(ref) {
      if (!Utils.isMoment(ref)) {
        throw new TypeError('Moment expected: ' + typeof ref);
      }

      return ref;
    }
  }, {
    key: "toFixed",
    value: function toFixed(ref) {
      try {
        return ref.toFixed(2).toString();
      } catch (_a) {
        throw new TypeError('Number expected: ' + typeof ref);
      }
    }
    /**
     * Compares two moments and returns 0, -1 or 1. Convenient for sorting list or arrays of moments.
     * @param a
     * @param b
     */

  }, {
    key: "dateComparator",
    value: function dateComparator(a, b) {
      return a.isSame(b) ? 0 : a.isBefore(b) ? -1 : 1;
    }
    /**
     * Returns length of common prefix of given lists in which the elements of lists are equal.
     * @param l1 list 1
     * @param l2 list 2
     */

  }, {
    key: "lengthOfCommonPrefix",
    value: function lengthOfCommonPrefix(l1, l2) {
      var res = 0;

      for (var i = 0; i < Math.min(l1.size, l2.size); i++) {
        if (l1.get(i) === l2.get(i)) {
          res = i + 1;
        } else {
          break;
        }
      }

      return res;
    }
    /**
     * Sort list of numbers
     * @param ref
     */

  }, {
    key: "sortNumbers",
    value: function sortNumbers(ref) {
      return ref.sort(function (a, b) {
        return a - b;
      });
    }
    /**
     * Sort array of numbers
     * @param ref
     */

  }, {
    key: "sortArrayOfNumbers",
    value: function sortArrayOfNumbers(ref) {
      if (!Utils.asArray(ref)) {
        throw new TypeError('Array expected: ' + typeof ref);
      }

      if (ref.length && !Utils.isNumber(ref[0])) {
        throw new TypeError('Number expected: ' + typeof ref);
      }

      return Utils.sortNumbers(ref);
    }
    /**
     * Sort list of strings
     * @param ref
     */

  }, {
    key: "sortStrings",
    value: function sortStrings(ref) {
      return ref.sort(function (a, b) {
        return a !== b ? a < b ? -1 : 1 : 0;
      });
    }
    /**
     * Sort array of strings
     * @param ref
     */

  }, {
    key: "sortArrayOfStrings",
    value: function sortArrayOfStrings(ref) {
      if (!Utils.asArray(ref)) {
        throw new TypeError('Array expected: ' + typeof ref);
      }

      if (ref.length && !Utils.isString(ref[0])) {
        throw new TypeError('String expected: ' + typeof ref);
      }

      return Utils.sortStrings(ref);
    }
    /**
     * Pads the string s with another string (multiple times, if needed) until the resulting string reaches the given length.
     * The padding is applied from the start of the current string.
     * @param s
     * @param targetLength
     * @param padString
     */

  }, {
    key: "padStart",
    value: function padStart(s, targetLength, padString) {
      var result = s;

      while (result.length < targetLength) {
        result = padString + result;
      }

      return result;
    }
    /**
     * Normalizes string for search purposes.
     * @param s
     */

  }, {
    key: "normalizeString",
    value: function normalizeString(s) {
      return s; // return s.toLowerCase().replace(/ /g, '');
    }
    /**
     * Converts string in camel case format to snake case format.
     * @param s
     */

  }, {
    key: "camelCaseToSnakeCase",
    value: function camelCaseToSnakeCase(s) {
      if (Utils.isUndefined(s) || s.length === 0) {
        return s;
      }

      return s[0].toLowerCase() + s.slice(1, s.length).replace(/[A-Z]/g, function (letter) {
        return "_".concat(letter.toLowerCase());
      });
    }
    /*
     * Complex validators
     */

    /**
     * Check object, if include all keys from keys array.
     *
     * @param ref Reference to object
     * @param keys Array of keys
     * @returns true if object does not contains all keys
     */

  }, {
    key: "objectHasKeys",
    value: function objectHasKeys(ref, keys) {
      var objectKeys = Object.keys(ref);
      return keys.every(function (value) {
        return objectKeys.indexOf(value) >= 0;
      });
    }
  }, {
    key: "assertDefined",
    value: function assertDefined(value) {
      if (value === null || value === undefined) {
        throw new Error('Value have to be defined');
      }

      return value;
    }
  }, {
    key: "assertNonNegative",
    value: function assertNonNegative(value) {
      if (value < 0) {
        throw new Error('Value must be greater or equal to zero');
      }

      return value;
    }
  }, {
    key: "assertPositive",
    value: function assertPositive(value) {
      if (value <= 0) {
        throw new Error('Value must be positive');
      }

      return value;
    }
  }, {
    key: "collectionToMap",
    value: function collectionToMap(entities, key) {
      return immutable_1.Map(entities.valueSeq().map(function (e) {
        return [key(e), e];
      }));
    }
  }, {
    key: "arrayToMap",
    value: function arrayToMap(entities, key) {
      return immutable_1.Map(entities.map(function (e) {
        return [key(e), e];
      }));
    }
    /**
     * Transforms entities to mapping by their ids.
     * @param entities
     */

  }, {
    key: "groupByUniqueIds",
    value: function groupByUniqueIds(entities) {
      return immutable_1.Map(entities.map(function (entity) {
        return [entity.id, entity];
      }));
    }
    /**
     * Returns category id from given list of categories (ordered from the lowest level to the root category).
     * @param categoryIds
     * @param level level of requested category
     */

  }, {
    key: "getCategoryIdWithLevel",
    value: function getCategoryIdWithLevel(categoryIds, level) {
      return categoryIds.get(categoryIds.size - level);
    }
    /**
     * Product external id is possibly compound of more identifiers. This function extracts the core one.
     */

  }, {
    key: "getCustomerId",
    value: function getCustomerId(productExternalId) {
      var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Utils.EXTERNAL_ID_SEPARATOR;
      return productExternalId.split(separator)[0];
    }
    /**
     *  Gets part of externalId based on externalId length
     */

  }, {
    key: "getPartialExtId",
    value: function getPartialExtId(externalId, length) {
      var separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Utils.EXTERNAL_ID_SEPARATOR;

      if (!Utils.isString(externalId)) {
        return undefined;
      }

      var extIdArr = externalId.split(separator);
      var resultArr = extIdArr.map(function (part, index) {
        return index < length ? part : undefined;
      }).filter(function (part) {
        return part;
      });
      return resultArr.join(separator);
    }
    /**
     *  Gets part of externalId
     */

  }, {
    key: "getPartOfExternalId",
    value: function getPartOfExternalId(externalId, partIndex) {
      var separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Utils.EXTERNAL_ID_SEPARATOR;

      if (!Utils.isString(externalId)) {
        return undefined;
      }

      return externalId.split(separator)[partIndex];
    }
    /**
     * Computes exponential delay (in seconds): exponentialDelay(attemptCount) = (1/2) * (power(2, attemptCount) - 1) * 60.
     * For 0 attempts returns 0, for 2 attempts 90, for 4 attempts 450, ...
     * Also it is possible to limit max and min delay, see parameters maxDelayInSec and minDelayInSec.
     * Originally this was implemented to use in exports.
     */

  }, {
    key: "exponentialDelay",
    value: function exponentialDelay(attemptCount, maxDelayInSec, minDelayInSec) {
      var one = big_decimal_1.bigdecimal(1);
      var two = big_decimal_1.bigdecimal(2);
      var delayInSec = one.div(two) // tslint:disable-next-line:no-bitwise
      .mul((1 << attemptCount) - 1).mul(60);

      if (delayInSec.greaterThan(maxDelayInSec)) {
        return big_decimal_1.bigdecimal(maxDelayInSec);
      }

      if (delayInSec.lessThan(minDelayInSec)) {
        return big_decimal_1.bigdecimal(minDelayInSec);
      }

      return delayInSec;
    }
  }, {
    key: "fail",
    value: function fail(msg) {
      throw new Error(msg);
    }
  }, {
    key: "undefinedToNull",
    value: function undefinedToNull(t) {
      return t !== undefined ? t : null;
    }
  }, {
    key: "nullToUndefined",
    value: function nullToUndefined(t) {
      return t !== null && t !== undefined ? t : undefined;
    }
  }, {
    key: "mappedValueOrUndefined",
    value: function mappedValueOrUndefined(t, f) {
      return t !== null && t !== undefined ? f(t) : undefined;
    }
    /**
     * From collection of elements creates list of lists of max size equal to provided size.
     * @param input sequence to be chunked
     * @param size max size of chunk
     */

  }, {
    key: "chunk",
    value: function chunk(input, size) {
      var ret = [];
      var chunk = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = input.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var el = _step.value;

          if (chunk.length >= size) {
            ret.push(immutable_1.List(chunk));
            chunk = [];
          }

          chunk.push(el);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (chunk.length > 0) {
        ret.push(immutable_1.List(chunk));
      }

      return immutable_1.List(ret);
    }
    /**
     * Turns provided iterator into object mode Readable instance
     * @param iterator
     */

  }, {
    key: "iteratorToReadable",
    value: function iteratorToReadable(iterator) {
      return new (
      /*#__PURE__*/
      function (_stream_1$Readable) {
        _inherits(_class, _stream_1$Readable);

        function _class() {
          _classCallCheck(this, _class);

          return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
        }

        _createClass(_class, [{
          key: "_read",
          value: function _read(size) {
            var canPush = true;

            do {
              var v = iterator.next();

              if (v.done) {
                canPush = false;
                this.push(null);
              } else {
                size--;
                canPush = this.push(v.value);
              }
            } while (canPush && size > 0);
          }
        }]);

        return _class;
      }(stream_1.Readable))({
        objectMode: true
      });
    }
    /**
     * Turns provided iterable into object mode Readable instance
     * @param iterable
     */

  }, {
    key: "iterableToReadable",
    value: function iterableToReadable(iterable) {
      return Utils.iteratorToReadable(iterable[Symbol.iterator]());
    }
    /**
     * Writes content of provided iterable to given output stream.
     */

  }, {
    key: "writeIterableToStream",
    value: function writeIterableToStream(iterable, outputStream) {
      return Utils.writeIteratorToStream(iterable[Symbol.iterator](), outputStream);
    }
    /**
     * Writes content of provided iterator to given output stream. Finishes the stream afterwards.
     */

  }, {
    key: "writeIteratorToStream",
    value: function writeIteratorToStream(iterator, outputStream) {
      return new Promise(function (resolve, reject) {
        outputStream.on('error', function (err) {
          return reject(err);
        }).on('finish', resolve);
        var item = iterator.next();
        var canWrite = true;

        var write = function write() {
          while (!item.done && canWrite) {
            canWrite = outputStream.write(item.value);
            item = iterator.next();
          }

          if (item.done) {
            outputStream.end();
          } else {
            canWrite = true;
            outputStream.once('drain', write);
          }
        };

        write();
      });
    }
  }, {
    key: "consumerToWritable",
    value: function consumerToWritable(consumer) {
      return new (
      /*#__PURE__*/
      function (_stream_1$Writable) {
        _inherits(_class2, _stream_1$Writable);

        function _class2(opts) {
          var _this;

          _classCallCheck(this, _class2);

          _this = _possibleConstructorReturn(this, _getPrototypeOf(_class2).call(this, opts));
          _this.initialized = false;
          consumer.init().then(function () {
            return _this.afterInit();
          }, function (err) {
            return _this.afterInit(err);
          });
          return _this;
        }

        _createClass(_class2, [{
          key: "afterInit",
          value: function afterInit(err) {
            this.initialized = true;

            if (this.firstCallback) {
              if (err) {
                this.firstCallback(err);
              } else {
                this.consume(this.firstData, this.firstCallback);
              }
            } else if (err) {
              this.destroy(err);
            }
          }
        }, {
          key: "consume",
          value: function consume(chunk, callback) {
            var wait;

            try {
              wait = consumer.consume(chunk);
            } catch (err) {
              callback(err);
              return;
            }

            if (!wait) {
              callback();
            } else {
              wait.then(function () {
                return callback();
              }, function (err) {
                return callback(err);
              });
            }
          }
        }, {
          key: "_write",
          value: function _write(chunk, encoding, callback) {
            if (!this.initialized) {
              this.firstCallback = callback;
              this.firstData = chunk;
            } else {
              this.consume(chunk, callback);
            }
          }
        }, {
          key: "_final",
          value: function _final(callback) {
            consumer.finalize().then(function () {
              return callback();
            }, function (err) {
              return callback(err);
            });
          }
        }]);

        return _class2;
      }(stream_1.Writable))({
        objectMode: true
      });
    }
  }, {
    key: "getChunks",
    value: function getChunks(array, size) {
      var chunkedArr = [];
      var chunkCnt = Math.ceil(array.length / size);

      for (var i = 0; i < chunkCnt; i++) {
        chunkedArr.push(array.slice(i * size, Math.min((i + 1) * size, array.length)));
      }

      return chunkedArr;
    }
  }, {
    key: "doInBatches",
    value: function () {
      var _doInBatches = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(items, batchSize, batchAction) {
        var batch, processedItems, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, item;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                batch = immutable_1.List().asMutable();
                processedItems = immutable_1.List();
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 5;
                _iterator2 = items[Symbol.iterator]();

              case 7:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 20;
                  break;
                }

                item = _step2.value;
                batch = batch.push(item);

                if (!(batch.size >= batchSize)) {
                  _context.next = 17;
                  break;
                }

                _context.t0 = processedItems;
                _context.next = 14;
                return batchAction(batch.asImmutable());

              case 14:
                _context.t1 = _context.sent;
                processedItems = _context.t0.concat.call(_context.t0, _context.t1);
                batch = immutable_1.List().asMutable();

              case 17:
                _iteratorNormalCompletion2 = true;
                _context.next = 7;
                break;

              case 20:
                _context.next = 26;
                break;

              case 22:
                _context.prev = 22;
                _context.t2 = _context["catch"](5);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t2;

              case 26:
                _context.prev = 26;
                _context.prev = 27;

                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }

              case 29:
                _context.prev = 29;

                if (!_didIteratorError2) {
                  _context.next = 32;
                  break;
                }

                throw _iteratorError2;

              case 32:
                return _context.finish(29);

              case 33:
                return _context.finish(26);

              case 34:
                if (batch.isEmpty()) {
                  _context.next = 40;
                  break;
                }

                _context.t3 = processedItems;
                _context.next = 38;
                return batchAction(batch.asImmutable());

              case 38:
                _context.t4 = _context.sent;
                processedItems = _context.t3.concat.call(_context.t3, _context.t4);

              case 40:
                return _context.abrupt("return", processedItems);

              case 41:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 22, 26, 34], [27,, 29, 33]]);
      }));

      return function doInBatches(_x, _x2, _x3) {
        return _doInBatches.apply(this, arguments);
      };
    }()
  }, {
    key: "doInBatchesNoResult",
    value: function () {
      var _doInBatchesNoResult = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(items, batchSize, batchAction) {
        var batch, numberOfBatches, batchCnt, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, item;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                batch = immutable_1.List().asMutable();
                numberOfBatches = Math.ceil(items.count() / batchSize);
                batchCnt = 1;
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context2.prev = 6;
                _iterator3 = items[Symbol.iterator]();

              case 8:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context2.next = 19;
                  break;
                }

                item = _step3.value;
                batch = batch.push(item);

                if (!(batch.size >= batchSize)) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 14;
                return batchAction(batch.asImmutable(), batchCnt === 1, batchCnt === numberOfBatches);

              case 14:
                batch = immutable_1.List().asMutable();
                batchCnt++;

              case 16:
                _iteratorNormalCompletion3 = true;
                _context2.next = 8;
                break;

              case 19:
                _context2.next = 25;
                break;

              case 21:
                _context2.prev = 21;
                _context2.t0 = _context2["catch"](6);
                _didIteratorError3 = true;
                _iteratorError3 = _context2.t0;

              case 25:
                _context2.prev = 25;
                _context2.prev = 26;

                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                  _iterator3.return();
                }

              case 28:
                _context2.prev = 28;

                if (!_didIteratorError3) {
                  _context2.next = 31;
                  break;
                }

                throw _iteratorError3;

              case 31:
                return _context2.finish(28);

              case 32:
                return _context2.finish(25);

              case 33:
                if (batch.isEmpty()) {
                  _context2.next = 36;
                  break;
                }

                _context2.next = 36;
                return batchAction(batch.asImmutable(), batchCnt === 1, true);

              case 36:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[6, 21, 25, 33], [26,, 28, 32]]);
      }));

      return function doInBatchesNoResult(_x4, _x5, _x6) {
        return _doInBatchesNoResult.apply(this, arguments);
      };
    }()
    /**
     * Collects elements from the stream into batches which are processed by the given function.
     * @param readable stream of elements
     * @param batchSize number of elements which are processed in one batch
     * @param batchAction function which shall process the batch
     * @returns concatenated results of the function called on all batches. Size of the result's list
     *          can differ from the stream's elements count.
     */

  }, {
    key: "doInBatchesOnStream",
    value: function () {
      var _doInBatchesOnStream = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(readable, batchSize, batchAction) {
        var result, batch, ended, wasSomeData, batchResult, chunk, _batchResult;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(batchSize <= 0)) {
                  _context3.next = 2;
                  break;
                }

                throw new Error('Batch size has to be greater than 0. Current value: ' + batchSize);

              case 2:
                result = [];
                batch = [];

              case 4:
                ended = false; // Wait till some data are available or end of stream occurs.

                _context3.next = 7;
                return new Promise(function (resolve, reject) {
                  readable.on('readable', function () {
                    return resolve();
                  });
                  readable.on('end', function () {
                    ended = true;
                    return resolve();
                  });
                  readable.on('error', function (reason) {
                    return reject(reason);
                  });
                });

              case 7:
                wasSomeData = false;

              case 8:
                if (!(batch.length >= batchSize)) {
                  _context3.next = 14;
                  break;
                }

                _context3.next = 11;
                return batchAction(immutable_1.List(batch));

              case 11:
                batchResult = _context3.sent;
                batchResult.forEach(function (r) {
                  return result.push(r);
                });
                batch.length = 0;

              case 14:
                chunk = readable.read(); // Load one element from stream's internal buffer to our buffer.

                if (!(chunk === null)) {
                  _context3.next = 17;
                  break;
                }

                return _context3.abrupt("break", 21);

              case 17:
                batch.push(chunk);
                wasSomeData = true;

              case 19:
                _context3.next = 8;
                break;

              case 21:
                if (!(!wasSomeData || ended)) {
                  _context3.next = 23;
                  break;
                }

                return _context3.abrupt("break", 25);

              case 23:
                _context3.next = 4;
                break;

              case 25:
                if (!(batch.length > 0)) {
                  _context3.next = 30;
                  break;
                }

                _context3.next = 28;
                return batchAction(immutable_1.List(batch));

              case 28:
                _batchResult = _context3.sent;

                _batchResult.forEach(function (r) {
                  return result.push(r);
                });

              case 30:
                return _context3.abrupt("return", immutable_1.List(result));

              case 31:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function doInBatchesOnStream(_x7, _x8, _x9) {
        return _doInBatchesOnStream.apply(this, arguments);
      };
    }()
    /**
     * Tries to find an element in the first collection, if the element doesn't exist, it looks to the
     * next one and so on...
     * @param key A provided key
     * @param maps A list of arguments to be passed to the method.
     * @returns The value associated with the provided key, or null if any Collection does not contain this key.
     */
    //TODO remove? Leads to bad programming habits - using merged map is faster than this O(log(n)) vs O(n * log(n))

  }, {
    key: "getFirstMapMatch",
    value: function getFirstMapMatch(key) {
      for (var _len = arguments.length, maps = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        maps[_key - 1] = arguments[_key];
      }

      for (var _i = 0; _i < maps.length; _i++) {
        var map = maps[_i];
        var item = map.get(key);

        if (!Utils.isValueMissing(item)) {
          return item;
        }
      }

      return null;
    }
    /**
     * It collects all elements of the given stream and it returns them in a list.
     */

  }, {
    key: "collectStream",
    value: function collectStream(stream) {
      return new Promise(function (resolve, reject) {
        var result = [];
        stream.on('data', function (chunk) {
          result.push(chunk);
        }).on('end', function () {
          return resolve(immutable_1.List(result));
        }).on('error', function (e) {
          return reject(e);
        });
      });
    }
  }, {
    key: "safeStringify",
    value: function safeStringify(anyValue) {
      // See https://stackoverflow.com/questions/11616630/how-can-i-print-a-circular-structure-in-a-json-like-format
      return util_1.inspect(anyValue, {
        depth: 10,
        maxArrayLength: Infinity,
        breakLength: Infinity
      });
    }
    /**
     * Simple utility for stripping tags from HTML document.
     * @param html
     */

  }, {
    key: "stripHtml",
    value: function stripHtml(html) {
      return html.replace('<br/>', '\n').replace('</p>', '\n\n').replace(/<[^>]+>/g, '');
    }
    /**
     * Function pipes provided streams in order they were passed to function
     * and creates promise that waits for finish event of result stream.
     * Also it waits for errors emitted on any of provided streams.
     * If any error occurs the promise is rejected.
     * @param stream Readable that is the very first stream in the pipeline.
     * @param streams Transforms and writable (the last stream) that should be piped.
     */

  }, {
    key: "streamsToPromise",
    value: function streamsToPromise(stream) {
      for (var _len2 = arguments.length, streams = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        streams[_key2 - 1] = arguments[_key2];
      }

      var resultStream = streams.reduce(function (piped, writable) {
        return piped.pipe(writable);
      }, stream);
      return new Promise(function (resolve, reject) {
        stream.on('error', function (err) {
          return reject(err);
        });
        streams.forEach(function (writable) {
          return writable.on('error', function (err) {
            return reject(err);
          });
        });
        resultStream.on('finish', function () {
          return resolve();
        });
      });
    }
    /**
     * Returns most frequent element in collection or {@code null} if collection is empty.
     * @param elements
     */

  }, {
    key: "mostFrequent",
    value: function mostFrequent(elements) {
      if (elements.isEmpty()) {
        return null;
      }

      var first = elements.first();
      return elements.groupBy(function (e) {
        return e;
      }).map(function (c) {
        return c.count();
      }).reduce(function (acc, count, elem) {
        return acc.count > count ? acc : {
          count: count,
          mostFrequent: elem
        };
      }, {
        count: 0,
        mostFrequent: first
      }).mostFrequent;
    }
    /**
     * Transforms map to reverse mapping where keys become values (and vice versa).
     * Note that this can lead to loss of some keys (values in resulting map)
     * when an original value was assigned with multiple different original keys
     * (do not use this method when this is not desired).
     * @param map
     */

  }, {
    key: "reverseMappingOfUnique",
    value: function reverseMappingOfUnique(map) {
      return map.mapEntries(function (entry) {
        return [entry[1], entry[0]];
      });
    }
    /**
     * Transforms map to reverse mapping where keys become values
     * and values become keys. New key (previous value) can have multiple corresponding values (previous keys).
     * @param map
     */

  }, {
    key: "reverseMapping",
    value: function reverseMapping(map) {
      return map.entrySeq().map(function (entry) {
        return [entry[1], entry[0]];
      }).groupBy(function (entry) {
        return entry[0];
      }).map(function (col) {
        return col.map(function (entry) {
          return entry[1];
        }).toSet();
      }).toMap();
    }
    /**
     * Get from array element with highest occurrence or last element
     * @param array
     */

  }, {
    key: "getElementWithHighestOccurrence",
    value: function getElementWithHighestOccurrence(array) {
      var maxCount = 0;
      var mapWithCounts = immutable_1.Map();
      var maxEl = null;
      array.forEach(function (item) {
        var mapWithCountsEl = mapWithCounts.get(item);

        if (mapWithCountsEl) {
          mapWithCounts = mapWithCounts.set(item, mapWithCountsEl + 1);
        } else {
          mapWithCounts = mapWithCounts.set(item, 1);
        }

        if (maxCount <= mapWithCounts.get(item)) {
          maxCount = mapWithCounts.get(item);
          maxEl = item;
        }
      });
      return maxEl;
    }
  }]);

  return Utils;
}();

exports.Utils = Utils;
Utils.EXTERNAL_ID_SEPARATOR = ':';
/**
 * Placeholder for object ID that is not (yet) assigned
 */

Utils.VOID_ID = '';
/**
 * Placeholder for numeric ID.
 */

Utils.VOID_NUMERIC_ID = -999;
/**
 * Placeholder for any str in object that is not (yet) assigned
 */

Utils.UNDEFINED_STR = '----------------'; // 16 chars

/**
 * Placeholder for any num in object that is not (yet) assigned
 */

Utils.UNDEFINED_NUL = NaN;
/**
 * Constant which is used internally for unbounded date (represented by null) in future.
 * WARNING: Moment is mutable. Do not use it directly. Instead work with a copy returned
 * by {@link #getFarFutureMoment()};
 */

Utils.FAR_FUTURE = moment('2120-12-31T23:59:59.999Z'); // TODO ZSt - must define correct date
// FIXME JGr - Can we use this constant instead of FAR_FUTURE?

/**
 * WARNING: Moment is mutable. Do not use it directly. Instead work with a copy returned
 * by {@link #getFarFutureMomentForPriceList()};
 */

Utils.FAR_FUTURE_PRICELIST = moment('2049-12-30T23:59:59.999Z');
/**
 * Constant which is used internally for unbounded date in past.
 * WARNING: Moment is mutable. Do not use it directly. Instead work with a copy returned
 * by {@link #getFarPastMoment()};
 */

Utils.FAR_PAST = moment('1969-12-31T23:00:00.000Z');
/**
 * Runs several stream of computation in limited parallelism. Each stream is represented by Promise. When promise
 * resolves, next promise is started. When promise is rejected, overall computation is rejected. Promises are created
 * by provided `factory` function from configuration object. Configuration objects are read from `config` function.
 * New promises are created until `config` returns null or undefined value. The function ensures that no more than
 * `parallelism` promises are running at once.
 * @param parallelism max number of promises running in parallel.
 * @param config function that generated configurations for promise factory
 * @param factory factory transforming configuration into running promise
 * @param reducer function that combines result of promises into one value
 * @param init seed for reducer
 * @returns promise that is resolved after all promises from factory are resolved, the returned promise contains combined
 * result of them.
 */

function promisePool(parallelism, config, factory, reducer, init) {
  var acc = init;
  var failed = false;
  var finished = false;
  var running = 0;

  function executor(resolve, reject) {
    var cfgFun = config instanceof Function ? config : function () {
      var n = config.next();
      return n.done ? null : n.value;
    };

    function fail(err) {
      if (!failed) {
        failed = true;
        reject(err);
      }
    }

    function run() {
      if (finished || failed) {
        return;
      }

      try {
        var cfg = cfgFun();

        if (cfg === null || cfg === undefined) {
          finished = true;
          return;
        }

        var promise = factory(cfg);

        if (!promise) {
          fail(new Error('Factory failed to return a promise'));
          return;
        }

        running++;
        promise.then(function (res) {
          if (acc !== undefined && reducer !== undefined) {
            acc = reducer(res, acc);
          }

          run();
          running--;

          if (running === 0 && finished && !failed) {
            resolve(acc);
          }
        }, function (err) {
          fail(err);
        });
      } catch (err) {
        fail(err);
      }
    }

    run();

    if (finished) {
      // in case that config set is empty
      resolve(acc);
    }

    for (var i = 1; i < parallelism; i++) {
      run();
    }
  }

  return new Promise(executor);
}

exports.promisePool = promisePool;
/**
 * <p>Waits for successful result (true result) of provided check action or rejected result after maximum allowed error attempts exceed. The
 * errors attempt counter is reset every time a successful checkAction function call is made.</p>
 *
 * @param checkAction The check function, function waits for returned 'true' value.
 * @param att Number of all attempts.
 * @param attErr Number of error attempts. If attErrAllowed is defined, fn rejects after maximum number of error attempts exceeds.
 * @param attAllowed Limits maximum number of attempts allowed. If not defined, there is no limit.
 * @param attErrAllowed Limits maximum number of error attempts allowed. Limit is reset after successful checkAction function call.
 * @param retryAfterSeconds Minimum period, after which we wait for next att.
 */

function waitForConditionFulfillOrReject(_x10, _x11, _x12) {
  return _waitForConditionFulfillOrReject.apply(this, arguments);
}

function _waitForConditionFulfillOrReject() {
  _waitForConditionFulfillOrReject = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(checkAction, att, attErr) {
    var attAllowed,
        attErrAllowed,
        retryAfterSeconds,
        sleep,
        sleepTimeInMs,
        result,
        message,
        stack,
        _args4 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            attAllowed = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : null;
            attErrAllowed = _args4.length > 4 ? _args4[4] : undefined;
            retryAfterSeconds = _args4.length > 5 && _args4[5] !== undefined ? _args4[5] : 60;

            if (!(attAllowed && attAllowed <= att)) {
              _context4.next = 5;
              break;
            }

            throw new Error("Allowed maximum attempts exceeded.");

          case 5:
            console.log("waitForConditionFulfillOrReject started, # of attempts ".concat(att));
            console.log("waitForConditionFulfillOrReject started, att=".concat(att, ", attErr=").concat(attErr, ", attAllowed=").concat(attAllowed, ", attErrAllowed=").concat(attErrAllowed));
            sleep = util_1.promisify(setTimeout);
            sleepTimeInMs = retryAfterSeconds * 1000;
            result = false;
            _context4.prev = 10;
            _context4.next = 13;
            return checkAction();

          case 13:
            result = _context4.sent;
            _context4.next = 28;
            break;

          case 16:
            _context4.prev = 16;
            _context4.t0 = _context4["catch"](10);

            if (!(attErr >= attErrAllowed)) {
              _context4.next = 20;
              break;
            }

            throw _context4.t0;

          case 20:
            message = _context4.t0.message ? _context4.t0.message.toString() : '?';
            stack = Utils.isString(_context4.t0.stack) ? _context4.t0.stack : '';
            console.log("Error thrown in check action while waiting for a condition to fulfill or reject but the error limit is not exceeded. Waiting\n            continues. Origin: ".concat(message, "\n").concat(stack));
            _context4.next = 25;
            return sleep(sleepTimeInMs);

          case 25:
            _context4.next = 27;
            return this.waitForConditionFulfillOrReject(checkAction, att + 1, attErr + 1, attAllowed, attErrAllowed, retryAfterSeconds);

          case 27:
            return _context4.abrupt("return", _context4.sent);

          case 28:
            if (result) {
              _context4.next = 34;
              break;
            }

            _context4.next = 31;
            return sleep(sleepTimeInMs);

          case 31:
            _context4.next = 33;
            return this.waitForConditionFulfillOrReject(checkAction, att + 1, 0, attAllowed, attErrAllowed, retryAfterSeconds);

          case 33:
            return _context4.abrupt("return", _context4.sent);

          case 34:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this, [[10, 16]]);
  }));
  return _waitForConditionFulfillOrReject.apply(this, arguments);
}

exports.waitForConditionFulfillOrReject = waitForConditionFulfillOrReject;